module.exports = __webpack_public_path__ + "static/fassadenschnitt-ff0567e14a93c230d157711adacc14f3.png";